module.exports = __webpack_public_path__ + "img/img2-1.0ba491c1.png";